import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { UserRole } from '../models/auth.interface';

// The session was resolved by the app initializer (or a password sign-in), so this is a plain read.
// The API enforces SUPER_ADMIN on every call; this only keeps anyone else off the screens.
export const authGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  if (authService.currentUser()?.role === UserRole.SUPER_ADMIN) {
    return true;
  }

  // Keep where they were going (a Slack link to a ticket, say), so signing in lands them there.
  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};
